import React, { useState } from "react";
import "./OrderTracking.css";
import api from "../services/api";

const OrderTracking = () => {
  const steps = [
    "Order Pending",
    "Order Confirmed",
    "Order Shipped",
    "Order Delivered",
  ];

  const [orderId, setOrderId] = useState("");
  const [orderTrackingStatus, setOrderTrackingStatus] = useState("");
  const [orderInfo, setOrderInfo] = useState("");

  // 🔹 Track Order Function
  const handleTrackOrder = () => {
    if (!orderId) {
      alert("Please enter an Order ID!");
      return;
    }

    api
      .post("fetch-order-tracking-status", { order_tnx_id: orderId })
      .then((res) => {
        setOrderTrackingStatus(res.data.order_status_id); 
        setOrderInfo(res.data); 
      })
      .catch((err) => {
        console.log(err);
      });
  };

 

  // 🔥 Dynamic Step Activation Logic
  const getActiveStep = () => {
    if (orderTrackingStatus === 1 || orderTrackingStatus === "1") return 0;
    if (orderTrackingStatus === 2 || orderTrackingStatus === "2") return 2;
    if (orderTrackingStatus === 3 || orderTrackingStatus === "3") return 3;
    return -1; // Default: no active step
  };

  const activeStep = getActiveStep();

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-10">

          <div className="card shadow-sm border-0 rounded-3 gfg-card">
            <div className="card-body">

              {/* Title */}
              <h3 className="fw-bold text-center text-success mb-4">
                Order Tracking
              </h3>

              {/* 🔹 Input + Buttons */}
              <div className="input-group mb-4">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Enter Order ID..." 
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                />
                <button className="btn btn-primary" onClick={handleTrackOrder}>
                  Track Now 🚚
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    setOrderId("");
                    setOrderTrackingStatus("");
                  }}
                >
                  Reset ♻️
                </button>
              </div>
              {orderInfo && 
                <div className="row mb-4">
                  <div className="col-md-6">
                    <p className="mb-0 fw-semibold">
                      Order ID : <span className="text-success">#{orderInfo.order_tnx_id}</span>
                    </p>
                  </div>
                  
                    <div className="col-md-6 text-end">
                      <p className="mb-1 fw-semibold">
                        Expected Arrival:{" "}
                        <span className="badge bg-primary rounded-pill px-3 py-2 ms-2">
                          {orderInfo?.order_date
                            ? new Date(
                                new Date(orderInfo.order_date).setDate(
                                  new Date(orderInfo.order_date).getDate() + 5
                                )
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : ""}
                        </span>
                      </p>
                    </div>
                
                </div>
               }

              {/* Progress Circles */}
            <div className="tracking-wrapper mb-4">
              <ul className="tracking-steps list-unstyled d-flex justify-content-between position-relative">
                {steps.map((step, index) => (
                  <li className="text-center" key={index}>
                    <div
                      className={`step-circle ${activeStep !== -1 && index <= activeStep ? "active" : ""}`}
                    >
                      {activeStep !== -1 && index <= activeStep && (
                        <span style={{ marginTop: "2px", display: "inline-block" }}>✔️</span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>

              {/* Step Labels */}
              <div className="row text-center fw-semibold">
                {steps.map((label, i) => (
                  <div className="col" key={i}>
                    {label}
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default OrderTracking;
